export const handleErrorDelete = (errors, name) => {
    let err = { ...errors };
    err && delete err[name];
    return err;
};
